/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Contract, ContractFactory, testMethod, callMethod, multicallMethods, fetchContractState, ContractInstance, } from "@alephium/web3";
import { default as TokenBridgeContractJson } from "../token_bridge/TokenBridge.ral.json";
import { getContractByCodeHash } from "./contracts";
class Factory extends ContractFactory {
    constructor() {
        super(...arguments);
        this.consts = {
            TokenBridgeModule: BigInt(102075932637695572646848357),
            Path: {
                AttestTokenHandler: "00",
                TokenBridgeForChain: "01",
                TokenPool: "02",
            },
            ErrorCodes: {
                InvalidEmitChainId: BigInt(0),
                InvalidEmitAddress: BigInt(1),
                InvalidMessageSize: BigInt(2),
                InvalidSequence: BigInt(3),
                InvalidModule: BigInt(4),
                InvalidActionId: BigInt(5),
                InvalidVersion: BigInt(6),
                InvalidGuardianSetIndex: BigInt(7),
                InvalidGuardianSetSize: BigInt(8),
                InvalidSignatureSize: BigInt(9),
                InvalidSignatureGuardianIndex: BigInt(10),
                InvalidSignature: BigInt(11),
                GuardianSetExpired: BigInt(12),
                InvalidTargetChainId: BigInt(13),
                ContractStateMismatch: BigInt(14),
                InvalidRegisterChainMessage: BigInt(15),
                InvalidTokenId: BigInt(16),
                InvalidNonceSize: BigInt(17),
                TokenNotExist: BigInt(18),
                InvalidTransferTargetChain: BigInt(19),
                InvalidDestroyUnexecutedSequenceMessage: BigInt(20),
                InvalidCaller: BigInt(21),
                ArbiterFeeLessThanAmount: BigInt(22),
                InvalidAttestTokenMessage: BigInt(23),
                InvalidPayloadId: BigInt(24),
                InvalidTransferMessage: BigInt(25),
                ExpectRemoteToken: BigInt(26),
                InvalidConsistencyLevel: BigInt(27),
                InvalidUpdateRefundAddressMessage: BigInt(28),
                TransferAmountLessThanMessageFee: BigInt(29),
                InvalidAttestTokenArg: BigInt(30),
                InvalidAttestTokenHandler: BigInt(31),
                NotSupported: BigInt(32),
            },
            ActionId: {
                RegisterChain: "01",
                ContractUpgrade: "02",
                DestroyUnexecutedSequences: "f0",
                UpdateMinimalConsistencyLevel: "f1",
                UpdateRefundAddress: "f2",
            },
            PayloadId: { Transfer: "01", AttestToken: "02" },
        };
        this.tests = {
            parseAndVerifyGovernanceVAA: (params) => __awaiter(this, void 0, void 0, function* () {
                return testMethod(this, "parseAndVerifyGovernanceVAA", params);
            }),
            createAttestTokenHandler: (params) => __awaiter(this, void 0, void 0, function* () {
                return testMethod(this, "createAttestTokenHandler", params);
            }),
            createLocalAttestTokenHandler: (params) => __awaiter(this, void 0, void 0, function* () {
                return testMethod(this, "createLocalAttestTokenHandler", params);
            }),
            parseAndVerifyRegisterChain: (params) => __awaiter(this, void 0, void 0, function* () {
                return testMethod(this, "parseAndVerifyRegisterChain", params);
            }),
            registerChain: (params) => __awaiter(this, void 0, void 0, function* () {
                return testMethod(this, "registerChain", params);
            }),
            upgradeContract: (params) => __awaiter(this, void 0, void 0, function* () {
                return testMethod(this, "upgradeContract", params);
            }),
            destroyUnexecutedSequenceContracts: (params) => __awaiter(this, void 0, void 0, function* () {
                return testMethod(this, "destroyUnexecutedSequenceContracts", params);
            }),
            updateMinimalConsistencyLevel: (params) => __awaiter(this, void 0, void 0, function* () {
                return testMethod(this, "updateMinimalConsistencyLevel", params);
            }),
            getRefundAddress: (params) => __awaiter(this, void 0, void 0, function* () {
                return testMethod(this, "getRefundAddress", params);
            }),
            updateRefundAddress: (params) => __awaiter(this, void 0, void 0, function* () {
                return testMethod(this, "updateRefundAddress", params);
            }),
            getMessageFee: (params) => __awaiter(this, void 0, void 0, function* () {
                return testMethod(this, "getMessageFee", params);
            }),
            attestToken: (params) => __awaiter(this, void 0, void 0, function* () {
                return testMethod(this, "attestToken", params);
            }),
            nextSendSequence: (params) => __awaiter(this, void 0, void 0, function* () {
                return testMethod(this, "nextSendSequence", params);
            }),
            createLocalTokenPool: (params) => __awaiter(this, void 0, void 0, function* () {
                return testMethod(this, "createLocalTokenPool", params);
            }),
            createRemoteTokenPool: (params) => __awaiter(this, void 0, void 0, function* () {
                return testMethod(this, "createRemoteTokenPool", params);
            }),
            updateRemoteTokenPool: (params) => __awaiter(this, void 0, void 0, function* () {
                return testMethod(this, "updateRemoteTokenPool", params);
            }),
            transferToken: (params) => __awaiter(this, void 0, void 0, function* () {
                return testMethod(this, "transferToken", params);
            }),
        };
    }
    at(address) {
        return new TokenBridgeInstance(address);
    }
}
// Use this object to test and deploy the contract
export const TokenBridge = new Factory(Contract.fromJson(TokenBridgeContractJson, "", "3921ab78ca073b5125b2ff7e4232e72f2c1c62554bbc8f81d39e769e6bcf349c"));
// Use this class to interact with the blockchain
export class TokenBridgeInstance extends ContractInstance {
    constructor(address) {
        super(address);
        this.methods = {
            getRefundAddress: (params) => __awaiter(this, void 0, void 0, function* () {
                return callMethod(TokenBridge, this, "getRefundAddress", params === undefined ? {} : params, getContractByCodeHash);
            }),
            getMessageFee: (params) => __awaiter(this, void 0, void 0, function* () {
                return callMethod(TokenBridge, this, "getMessageFee", params === undefined ? {} : params, getContractByCodeHash);
            }),
        };
    }
    fetchState() {
        return __awaiter(this, void 0, void 0, function* () {
            return fetchContractState(TokenBridge, this);
        });
    }
    multicall(calls) {
        return __awaiter(this, void 0, void 0, function* () {
            return (yield multicallMethods(TokenBridge, this, calls, getContractByCodeHash));
        });
    }
}
